const e = (o)=>`${(parseFloat(o) / 16).toFixed(3)}rem`;
export { e as pxToRem };
